export const CUSTOMER_TAG_DELETE = 'CUSTOMER_TAG_DELETE';
export const SEARCH_CUSTOMER_TAG = 'SEARCH_CUSTOMER_TAG';
export const LIST_ALL_CUSTOMER_TAG = 'LIST_ALL_CUSTOMER_TAG';
export const LIST_RECENT_CUSTOMER_TAG = 'LIST_RECENT_CUSTOMER_TAG';
export const LIST_CUSTOMER_TAG = 'LIST_CUSTOMER_TAG';
export const UPDATE_CUSTOMER_TAG = 'UPDATE_CUSTOMER_TAG';
export const CREATE_CUSTOMER_TAG = 'CREATE_CUSTOMER_TAG';